import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BiReportComponent } from './bi-report/bi-report.component';
import { ContributorsComponent } from './contributors/contributors.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FunnelReportComponent } from './funnel-report/funnel-report.component';
import { HomeComponent } from './home/home.component';
// import { LoginComponent } from './login/login.component';
import { PanelListComponent } from './panel-list/panel-list.component';
import { PerformanceTrackerComponent } from './performance-tracker/performance-tracker.component';
import { ProjectComponent } from './project/project.component';
import { QualListComponent } from './qual/qual-list/qual-list.component';
// import { QualComponent } from './qual/qual.component';
import { RecruiterMainComponent } from './recruiters/recruiter.main.component';
import { FileViewerComponent } from './repository/file-viewer/file-viewer.component';
import { ReportDetailsComponent } from './repository/report-details/report-details.component';
import { RepositoryComponent } from './repository/repository-report/repository.component';
import { VisibilityControlComponent } from './visibility-control/visibility-control.component';
import { TableExtractionComponent } from './repository/table-extraction/table-extraction.component';
import { CustomPreloadingStrategyService } from './services/custom-preloading-strategy.service';
// import { ExternalVocComponent } from './shared/external-voc/external-voc.component';
// import { ExcelViewerComponent } from './repository/excel-viewer/excel-viewer.component';
import { ExternalFileUploadComponent } from './repository/report-details/external-file-upload/external-file-upload.component';
import { WildComponent } from './shared/wild/wild.component';
import { MobileLoginPageComponent } from './mobile-login-page/mobile-login-page.component';
import { StudySurveyComponent } from './study-survey/study-survey.component';
import { CommonModule } from '@angular/common';
import { CreatToplineComponent } from './repository/creat-topline/creat-topline.component';
import { DiaryDayWiseComponent } from './diary/diary-day-wise/diary-day-wise.component';
import { DiaryCenterWiseComponent } from './diary/diary-center-wise/diary-center-wise.component';
import { SurveyBuilderResearchComponent } from './survey-builder-research/survey-builder-research.component';
import { DiaryTestComponent } from './diary/diary-test/diary-test.component';
import { CallRecordingComponent } from './repository/call-recording/call-recording.component';
import { FileViewComponent } from './file-view/file-view.component';
import { TermandcondComponent } from './termandcond/termandcond.component';
import { VocIntroPngComponent } from './shared/insights/voc-intro-png/voc-intro-png.component';
import { UserLoginComponent } from './user-login/user-login.component';
import { HomeDashboardComponent } from './home-dashboard/home-dashboard.component';

const routes: Routes = [
  // { path: '', component: LoginComponent },
  // { path: 'login', component: LoginComponent },
  { path: '', component: UserLoginComponent },
  { path: 'login', component: UserLoginComponent },
  { path: 'moblieLogin', component: MobileLoginPageComponent },
  { path: 'file-view/:uuid',component:FileViewComponent},
  { path: 'tnc',component:TermandcondComponent},
  {path : 'home-dashboard', component: HomeDashboardComponent},
  // { path: 'eagle-live', loadChildren:  () => import('./eagle-live/eagle-live.module').then(m => m.EagleLiveModule) },
  { path: 'file-upload/:token', component: ExternalFileUploadComponent },
  // { path:'video/:uuid', component:ExternalVocComponent},
  { path: 'eagle-live', loadChildren: () => import('./eagle-live/eagle-live.module').then(m => m.EagleLiveModule) },
  { path: 'qa-report', loadChildren: () => import('./qa-report-dashboard/qa-report-dashboard.module').then(m => m.QAReportDashboardModule) },
  { path: 'ama', loadChildren: () => import('./ama/ama.module').then(m => m.AmaModule) },
  { path: 'trinity', loadChildren: () => import('./trinity/trinity.module').then(m => m.TrinityModule) },
  { path: 'client-master', loadChildren: () => import('./client-master/client-master.module').then(m => m.ClientMasterModule) },
  { path: 'dash-suite', loadChildren: () => import('./superset-dashboard/superset-dashboard.module').then(m => m.SupersetDashboardModule) },
  { path: 'express', loadChildren: () => import('./express/express.module').then(m => m.ExpressModule) },
  { path: 'contract', loadChildren: () => import('./contract/contract.module').then(m => m.ContractModule) },
  { path: 'repo', loadChildren: () => import('./repository/repository.module').then(m => m.RepositoryModule) },
  { path: 'topline', loadChildren: () => import('./topline/topline.module').then(m => m.ToplineModule) },
  { path: 'qual', loadChildren: () => import('./qual/qual.module').then(m => m.QualModule) },
  { path: 'mrsi', loadChildren: () => import('./mrsi/mrsi.module').then(m => m.MrsiModule) },
  { path: 'video/:uuid', data: {preload: true}, loadChildren: () => import('./external-voc/external-voc.module').then(m => m.ExternalVOCModule) },
  { path: 'consumervoice', data: {preload: true}, loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule) },
  { path: 'consumer-immersions', loadChildren: () => import('./consumer-immersions/consumer-immersions.module').then(m => m.ConsumerImmersionsModule) },
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },

  // { path: 'qual', component: QualComponent, 
  //   children:[
  //     {
  //       path:'interview/:uuid',
  //       component:QualListComponent
  //     },{
  //       path:'report/:uuid',
  //       component:ReportDetailsComponent
  //     },{
  //       path:'reports/file-view',
  //       component:FileViewerComponent
  //     }
  //   ]
  // },
  { path: 'user-manager', loadChildren: () => import('./user-manager/user-manager.module').then(m => m.UserManagerModule) },
  // {
  //   path: 'home', component: HomeComponent,
  //   children: [
  //     {
  //       path: 'projects',component: ProjectComponent,
  //     },
  //     {
  //       path: 'projects/:id',component: DashboardComponent
  //     },
  //     { path: 'panel-list/:id', component: PanelListComponent },
  //     {
  //       path: 'projects/:id',component: DashboardComponent
  //     },
  //     {
  //       path: 'recruiters',component: RecruiterMainComponent
  //     },
  //     {
  //       path: 'recruiter/:id',component: DashboardComponent
  //     },
  //     {
  //       path: 'contributors',component: ContributorsComponent,
  //     },
  //     {
  //       path: 'home/recruiters-list/:id',component: RecruiterMainComponent
  //     },
  //     {
  //       path: 'dashboard',component: DashboardComponent,
  //       // children: [
  //       //   {
  //       //    path: 'dashboard/:id',
  //       //    component: RecruiterMainComponent
  //       //  }
  //       // ]
  //     },
  //     {
  //       path: 'performance-tracker/:id',
  //       component: PerformanceTrackerComponent
  //     },
  //     {
  //       path: 'research-survey/:id',
  //       component: SurveyBuilderResearchComponent
  //     },
  //     {
  //       path: 'bi-report/:id',
  //       component: BiReportComponent
  //     },
  //     {
  //       path: 'funnel-report/:id',
  //       component: FunnelReportComponent
  //     },
  //     {
  //       path: 'term-report/:id',
  //       component: FunnelReportComponent
  //     },
  //     {
  //       path: 'utm-report/:id',
  //       component: FunnelReportComponent
  //     },
  //     {
  //       path: 'summary-report/:id',
  //       component: FunnelReportComponent
  //     },
  //     {
  //       path: 'visibility/:id',
  //       component: VisibilityControlComponent
  //     },
  //     {
  //       path: 'dashboard/:id',
  //       component: RecruiterMainComponent
  //     },
  //     {
  //       path: 'projects/dashboard/:id',
  //       component: RecruiterMainComponent
  //     },
  //     { path: 'dairy-dashboard/test', component: DiaryTestComponent },
  //     { path: 'dairy-dashboard/day-wise/:id', component: DiaryDayWiseComponent },
  //     { path: 'dairy-dashboard/center-wise/:id', component: DiaryCenterWiseComponent },
      
  //     { path: 'survey/:uuid/:channel', component: StudySurveyComponent },

  //     // { path: 'repository-report', component: RepositoryComponent },
  //     // { path: 'repository-report/:id', component: RepositoryComponent },
  //     // { path: 'repository-report/details/:uuid', component: ReportDetailsComponent },

  //     // { path: 'repo', component: RepositoryComponent },
  //     // { path: 'repo/:id', component: RepositoryComponent },
  //     // { path: 'repo/details/:uuid', component: ReportDetailsComponent },
  //     // { path: 'repository-report/table-extraction/:uuid', component:TableExtractionComponent},

  //     // { path: 'repository-report/file-view', component: FileViewerComponent },
  //     // { path: 'repository-report/file-view/:uuid', component: FileViewerComponent },

  //     // { path: 'repository-report/excel-view/:uuid', component: ExcelViewerComponent },
  //     // { path: 'repository-report/topline/:uuid', component:CreatToplineComponent},
  //     // { path: 'repository-report/topline/alias/:uuid', component:CreatToplineComponent},
      
  //     { path: 'repository-report/call-recording/:uuid', component: CallRecordingComponent },

  //     //  {path:'qual-report/details/:uuid', component:ReportDetailsComponent},

  //     // {
  //     //   path:'qual/interview/:uuid',
  //     //   component:QualListComponent
  //     // },

  //     // { path:'qual/report/:uuid', component:ReportDetailsComponent},
  //     // { path:'qual/reports/file-view/:uuid', component:FileViewerComponent},
  //     // { path:'qual/table-extraction/:uuid', component: TableExtractionComponent },

  //     // {path:'access-denied' , component: WildComponent},
  //     // {path:'test-voc' , component: VocIntroPngComponent},

  //   ],
  // },
  // { path: 'survey-panel', loadChildren: () => import('./serveypanel/serveypanel.module').then(m => m.ServeypanelModule) },
  // { path: 'surveys/:id', loadChildren: () => import('./serveypanel/serveypanel.module').then(m => m.ServeypanelModule) },
  // { path: 'survey-panel/:id', loadChildren: () => import('./serveypanel/serveypanel.module').then(m => m.ServeypanelModule) },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    // RouterModule.forRoot(routes),
    RouterModule.forRoot(routes, { preloadingStrategy: CustomPreloadingStrategyService, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
